export function setSmallCardSize(element, fontSizeRatio = null, lineHeightRatio = null) {
  const { width } = element.getBoundingClientRect();
  const fontSize = width * (fontSizeRatio || 0.035);
  const lineHeight = width * (lineHeightRatio || 0.045);
  element.style.fontSize = `${fontSize}px`;
  element.style.lineHeight = `${lineHeight}px`;
}

export function countLines(element) {
  const buffer = document.createElement("textarea");

  buffer.style.border = "none";
  buffer.style.height = "0";
  buffer.style.overflow = "hidden";
  buffer.style.padding = "0";
  buffer.style.position = "absolute";
  buffer.style.left = "0";
  buffer.style.top = "0";
  buffer.style.zIndex = "-1";

  document.body.appendChild(buffer);

  let cs = window.getComputedStyle(element);
  let lh = parseInt(cs.lineHeight, 10);

  if (isNaN(lh)) {
    lh = parseInt(cs.fontSize, 10);
  }

  buffer.style.width = `${element.clientWidth}px`;
  buffer.style.paddingLeft = cs.paddingLeft;
  buffer.style.paddingRight = cs.paddingRight;

  buffer.style.font = cs.font;
  buffer.style.letterSpacing = cs.letterSpacing;
  buffer.style.whiteSpace = cs.whiteSpace;
  buffer.style.wordBreak = cs.wordBreak;
  buffer.style.wordSpacing = cs.wordSpacing;
  buffer.style.wordWrap = cs.wordWrap;

  buffer.value = element.value;

  const result = Math.floor(buffer.scrollHeight / lh) || 1;

  buffer.remove();

  return result === Infinity ? 0 : result;
}
